import { CourseDetailsContext } from 'components/CourseDetails';
import AnswerItemView from 'components/CourseDetails/AnswerItemView';
import { useContext, useMemo } from 'react';
import styles from './AnswersResult.module.scss';

const AnswersResult = () => {
  const { currentLecture, courseInfo } = useContext(CourseDetailsContext);
  const currentLectureIndex = useMemo(() => {
    if (!currentLecture) return -1;
    return (courseInfo.lectures || []).findIndex(
      (lec) => lec.id === currentLecture?.id
    );
  }, [courseInfo, currentLecture]);

  const correctCount = useMemo(() => {
    if (!currentLecture) return 0;
    return currentLecture?.questions?.filter((ques) => {
      const correctAnswer = ques.answers.find((ans) => ans.is_correct);
      return correctAnswer.id === ques.user_answer_id;
    }).length;
  }, [currentLecture]);
  if (!currentLecture) return <></>;
  return (
    <div className={styles.results}>
      <div className={styles.title}>
        レクチャー{currentLectureIndex + 1}の解答結果
        {'\n'}
        正解数: {correctCount}/{currentLecture?.questions?.length}
      </div>
      {currentLecture?.questions?.map((question, index) => {
        const correctAnswer = question.answers.find((ans) => ans.is_correct);
        const userAnswer = question.answers.find(
          (ans) => ans.id === question.user_answer_id
        );
        return (
          <div
            key={`${question.id}-${index}`}
            className={styles.questionResultItem}
          >
            <div className={styles.questionDetail}>
              {index + 1}. {question.detail}
            </div>
            <div className={styles.userAnswer}>
              {userAnswer ? (
                <AnswerItemView
                  type={
                    correctAnswer.id === question.user_answer_id
                      ? 'correct'
                      : 'wrong'
                  }
                  answerItem={userAnswer}
                />
              ) : (
                <div className={styles.notAnswerYet}>まだ解答していない</div>
              )}
            </div>
            {userAnswer && correctAnswer.id !== question.user_answer_id && (
              <div className={styles.correctAnswer}>
                <AnswerItemView answerItem={correctAnswer} type="correct" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AnswersResult;
